













































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import PagingUnit from '@/components/paging/paging.vue';
import { patrolManagementServe } from '@/api/installServer';
import PointEdit from './unit/point-edit.vue';
import BindPatrolEquip from './unit/bind-patrol-equip.vue';

@Component({
  components: { CollapseTransition, TreeUnit, PagingUnit, PointEdit, BindPatrolEquip },
  mixins: [TableStripe],
})
export default class PatrolLine extends Vue {
  private multipleSelection: any = []; // 批量操作数据

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 1000; // 数据总共多少条

  // 搜索表单数据
  formData: any = {
    name: '', // 巡检点
  };
  // table数据
  tableData: any[] = [];

  getNodeIds() {
    this.getPatrolPointAllData();
  }

  created() {
    this.getPatrolPointAllData();
  }

  private getPatrolPointAllData(): void {
    patrolManagementServe
      .getPatrolPointAllData({
        paging: true,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        search: this.formData.name ? this.formData.name : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getPatrolPointAllData();
  }

  /**
   *【表格】表格添加按钮
   * @Params
   * @return
   **/
  addHandle() {
    const FacilityEditComponent: any = this.$refs['patrolPointEdit'];
    FacilityEditComponent.showAddDialog();
  }

  /**
   *【表格】表格编辑按钮
   * @Params
   * @return
   **/
  handleTableEditBtnClick(data: any) {
    const FacilityEditComponent: any = this.$refs['patrolPointEdit'];
    FacilityEditComponent.showEditDialog(data.id);
  }

  handleBindPatrolEquipBtnClick(data: any) {
    const FacilityBindComponent: any = this.$refs['bindPatrolEquip'];
    FacilityBindComponent.showDialog(data);
  }

  /**
   *【编辑窗口】编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handlePatrolPointEditResponse() {
    this.getPatrolPointAllData();
  }
  /**
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getPatrolPointAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    // 获取全部数据
    this.getPatrolPointAllData();
  }

  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  /**
   *【表格】表格删除按钮
   * @Params
   * @return
   **/
  handleTableDeleteBtnClick(data: any) {
    this.$confirm('此操作将永久删除该巡检点, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.removePointData(data.id);
        this.getPatrolPointAllData();
      })
      .catch(() => {});
  }

  /**
   * 【按钮】批量操作按钮指令
   */
  handleBatchCommand(command: string) {
    if (this.multipleSelection.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    switch (command) {
      case 'remove':
        this.handleBatchRemove();
        break;
    }
  }

  /**
   * 批量删除
   */
  /**
   * 批量删除
   */
  handleBatchRemove() {
    this.$confirm('此操作将永久删除, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        const _selectList = this.multipleSelection.map((item: any) => item.id);
        this.removePointData(_selectList);
      })
      .catch(() => {});
  }

  /**
   * 【接口】删除巡检点
   * @param ids {String} 设备id
   */
  async removePointData(ids: string | string[]) {
    try {
      const res: any = await patrolManagementServe.deletePatrolPoint(ids);
      this.getPatrolPointAllData();
    } catch (e) {
      this.$message.warning('删除失败。');
      throw new Error();
    }
  }
}
